import { memo } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useAppSelector } from "@/store/hooks";
import { hasEventSession } from "@/lib/auth/session";

/**
 * Wraps protected routes. Redirects unauthenticated users to /auth/login,
 * preserving the attempted path so we can redirect back after login.
 */
const AuthGuard = memo(function AuthGuard() {
  const isAuthenticated = useAppSelector((s) => s.user.isAuthenticated);
  const isRestoringSession = useAppSelector((s) => s.user.isRestoringSession);
  const location = useLocation();

  if (isRestoringSession) {
    // While the session is being restored, don't render anything
    return (
      <div className="flex h-screen items-center justify-center py-20">
        <div
          className="h-8 w-8 animate-spin rounded-full border-4 border-neutral-200 border-t-[var(--sidebar-bg)] text-center"
          aria-label="Restoring session..."
        />
      </div>
    );
  }

  if (!isAuthenticated || !hasEventSession()) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
});

export default AuthGuard;
